import React, { useState } from 'react'
import Collapse from 'react-bootstrap/Collapse'

interface ListGroupItemProps {
  title: string
  children: string | null | undefined | React.ReactNode
  isOutsideBody?: boolean
}
const ListGroupItem: React.FC<ListGroupItemProps> = ({
  title,
  children,
  isOutsideBody = false
}) => {
  const [open, setOpen] = useState(true)
  const hasChildren =
    React.Children.toArray(children).filter(Boolean).length > 0

  return (
    <div
      className="list-group-item"
      style={{
        display: hasChildren ? '' : 'none'
      }}
    >
      <div
        className="details-section-header list-group-item-action d-flex justify-content-between"
        onClick={() => setOpen(!open)}
      >
        {title}
        <span className="material-icons">
          {!open ? 'keyboard_arrow_down' : 'keyboard_arrow_up'}
        </span>
      </div>
      <Collapse in={open}>
        <div>
          {!isOutsideBody && typeof children === 'string' && (
            <div
              className="details-section-body"
              dangerouslySetInnerHTML={{ __html: children }}
            />
          )}
          {!isOutsideBody && typeof children === 'object' && (
            <div className="details-section-body">{children}</div>
          )}
          {isOutsideBody && children}
        </div>
      </Collapse>
    </div>
  )
}

export default ListGroupItem
